import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import stores from './stores';

import Aura from '@primeuix/themes/aura';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import { Form } from '@primevue/forms';
import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';
import '@/assets/styles.scss';

import { currencyFormatter } from '@/utils/currency';

// Import PrimeVue components to register globally
import Card from 'primevue/card';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import RadioButton from 'primevue/radiobutton';
import Divider from 'primevue/divider';

const globalOptions = {
  mode: 'auto',
};

const app = createApp(App);

app.use(VueTelInput, globalOptions);
app.use(router);
app.use(stores);

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.app-dark',
    },
  },
});
app.use(Form);
app.use(ToastService);
app.use(ConfirmationService);

// Register PrimeVue components globally
app.component('Card', Card);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('InputText', InputText);
app.component('Textarea', Textarea);
app.component('InputNumber', InputNumber);
app.component('Dropdown', Dropdown);
app.component('Checkbox', Checkbox);
app.component('RadioButton', RadioButton);
app.component('Divider', Divider);

app.config.globalProperties.$currency = currencyFormatter;

app.mount('#app');